<template>
  <div />
</template>

<script>
import 'jQuery-Scanner-Detection'
export default {
  name: 'BarcodeScanner',

  props: {
    className: {
      default: '.v-application',
      type: String
    }
  },

  data: () => ({
    lastKeyCode: null
  }),

  mounted () {
    document.addEventListener('keydown', this.keyDownListener)
    $(document).scannerDetection({
      // Do something after scan is complete
      onComplete: barcode => {
        this.$emit('scan-init', barcode)
      }
    })
  },

  beforeDestroy () {
    document.removeEventListener('keydown', this.keyDownListener)
  },

  methods: {
    keyDownListener (event) {
      // Fix for stupid vendors that put Chrome "download tab" hotkeys in barcodes
      if (this.lastKeyCode === 'ControlLeft' && event.code === 'KeyJ') {
        event.preventDefault()
      }

      this.lastKeyCode = event.code
    }
  }
}
</script>
